import InvoiceMailing from './invoice-mailing.vue'
export default InvoiceMailing
